export enum PageTab {
  Users = 'users',
  Entities = 'entities',
  Invitations = 'invitations',
  SystemNotifications = 'system-notifications',
}
